<ng-container *transloco="let t; read: 'setPassword'">
    <div fxFill fxLayout.gt-xs="column" fxLayoutAlign.gt-xs="center center" class="session-expired-container">
        <div class="content-wrap">
            <header class="payment-header" fxLayout="column" fxLayoutAlign="center center">
                <img src="/assets/images/login-logo.png" />
            </header>
            <div fxLayout="column" fxLayoutAlign="center center" class="success-info ">
                <span class="icon" fxLayout fxLayoutAlign="center center">
                    <mat-icon>lock_open</mat-icon>
                </span>
                <h2>{{t('PasswordChanged')}}</h2>
                <p>{{t('PasswordChangedInfo')}}</p>
                <p>{{t('PasswordChangedInfo2')}}</p>
                <div class="form-button">
                    <button type="submit" (click)="gotoLogin()" mat-stroked-button color="primary">
                    {{t('ClickHeretoLogIn')}}
                  </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>